import {useState, useEffect} from 'react'
import '../../assets/css/colors.css'
import '../../assets/css/Principais.css'
import '../../assets/css/auxiliar/loading.css'
import Swal from 'sweetalert2'
import {useNavigate} from 'react-router-dom';
import GlobalVar from './GlobalVar'
import { ConsultaVendedora } from '../funcionalidades/bancoGet'


export const CarregaPreDefinicoes = props => {

    const navigate = useNavigate();

    const [carregou, setCarregou] = useState(false)
    const [usuario, setUsuario] = useState(GlobalVar.getSessionStorage('usuario')); 

      useEffect(()=>{
        if(carregou){
            navigate("/HomePage")
        }

      },[navigate, carregou])


    useEffect(()=>{
        if(!usuario) return;
        setTimeout(()=>{
            if(!carregou){
                navigate("/HomePage")
            }else{
                setCarregou(true)
            }
            },2000)
        if(usuario.fornInfo || !usuario.ven_numero) return;
        let usuarioTemp = GlobalVar.destructObj(usuario)
        ConsultaVendedora({CODVEND: usuario.ven_numero})
            .then(resp => {
                if(resp.Error){
                    Swal.fire({
                        icon: "warning",
                        title: "Algo deu errado",
                        text: resp.Error
                      });
                }else{
                    GlobalVar.setSessionStorage('usuario',{...usuarioTemp, vendedora: resp[0]})
                    setCarregou(true)
                }
            })
    },[usuario])


    return <>
        <div id="mainContainer" className='contentMain centerView' style={{backgroundColor: "#000000", height: '100vh', flexDirection: 'column'}}>


            
            <div style={{display: 'flex', flexDirection: 'row', alignItems: 'flex-start', justifyContent: 'center'}}>
               
               <div className="svgLoad logoSVGB"></div>
               <div className="svgLoad logoSVGA"></div>
               <div className="svgLoad logoSVGB"></div>
               <div className="svgLoad logoSVGI"></div>
               <div className="svgLoad logoSVGT"></div>
               <div className="svgLoad logoSVGA"></div>
           </div>
           <div className='textLoad'>CARREGANDO</div>
        </div>
    </>
}


export default CarregaPreDefinicoes;